import * as React from "react";
import { IconProps } from "../types";

const EyeOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M2.08799 10.132C1.63799 9.44899 1.63799 8.54999 2.08799 7.86699C3.10599 6.32399 5.34999 3.74899 8.99999 3.74899C12.65 3.74899 14.895 6.32299 15.912 7.86699C16.362 8.54999 16.362 9.44899 15.912 10.132C14.894 11.675 12.65 14.25 8.99999 14.25C5.34999 14.25 3.10499 11.676 2.08799 10.132Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default EyeOutlineIcon;
